<app-loading-spinner *ngIf="isLoading" />


<div *ngIf="!isLoading">
    <div class="flex flex-row items-center justify-end gap-5 ">
        <i class="fa-solid text-[#4A4A4A] fa-list text-lg dark:text-white"></i>

        <p class="text-[#4A4A4A] dark:text-white">Filter By</p>


        <div class="relative w-40 custom-status-dropdown-container">
            <!-- Hidden native select -->
            <select [(ngModel)]="selectStatus" class="hidden" (change)="filterStatus()">
                <option value="" selected disabled>Status</option>
                <option class="dark:bg-[#272F45]  text-textLight dark:text-textDark hover:bg-gray-300" value="Assigned">
                    Assigned</option>
                <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300" value="Closed">
                    Closed</option>
            </select>

            <!-- Custom dropdown trigger -->
            <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                (click)="toggleStatusDropdown()">
                <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                    <span>{{ selectStatus || 'Status' }}</span>
                    <div class="flex items-center">
                        <!-- X icon (shown ONLY when option is selected) -->
                        <i *ngIf="selectStatus" (click)="cancelStatus($event)"
                            class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                        <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                        <i *ngIf="isStatusDropdownOpen || !selectStatus"
                            class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                            [class.fa-angle-down]="!isStatusDropdownOpen"
                            [class.fa-angle-up]="isStatusDropdownOpen"></i>
                    </div>
                </div>
            </div>

            <!-- Custom dropdown options -->
            <div *ngIf="isStatusDropdownOpen"
                class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">

                <div *ngFor="let option of statusDropdownOptions; let i = index" (click)="selectStatusOption(option)"
                    class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center"
                    [ngClass]="{
                  'rounded-t-xl': i === 0,
                  'rounded-b-xl': i === statusDropdownOptions.length - 1
                }">

                    <span class="flex-grow">{{ option }}</span>
                    <i class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                </div>

            </div>
        </div>

        <div class="flex items-center mr-5 rounded-full  px-4 py-2 w-96 bg-[#F1F1F1] dark:bg-[#292929]">
            <input type="text" placeholder="Search by Ref No, EMP ID" [(ngModel)]="searchText"
                class="bg-transparent outline-none w-full text-textLight dark:text-textDark" (keyup.enter)="onSearch()"
                (keyup.esc)="offSearch()" />
            <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                (click)="onSearch()">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                </svg>
            </button>
            <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none" (click)="offSearch()">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

    </div>

    <div *ngIf="!hasData" class="flex flex-col items-center w-full h-screen mt-6">
        <p class="text-[#494949] my-6 dark:text-white">--No Data Available--</p>
        <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
    </div>


    <div *ngIf="hasData"
        class="overflow-x-auto mt-5 mr-5 border-gray-100 border-[2px] rounded-lg dark:border-[#202021]">
        <table class="w-full divide-y-2 overflow-hidden">
            <thead class=" text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] cursor-default">
                <tr>
                    <th class="px-6 py-3 text-left text-sm font-medium">Ref. No</th>
                    <th class="px-6 py-3 text-left text-sm font-medium">EMP ID</th>
                    <th class="px-6 py-3 text-left text-sm font-medium">Category</th>
                    <th class="px-6 py-3 text-center text-sm font-medium">Received At</th>
                    <th class="px-6 py-3 text-center text-sm font-medium">Status</th>
                    <th class="px-6 py-3 text-center text-sm font-medium">Action</th>
                    <th class="px-6 py-3 text-center text-sm font-medium">Reply</th>
                </tr>
            </thead>
            <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                <tr
                    *ngFor="let item of complainArr | paginate : { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems }; let i = index">
                    <!-- <tr *ngFor="let item of complainArr"> -->
                    <td class="px-6 py-4 text-sm text-gray-900 dark:text-[#C5C5C5]">{{item.refNo}}</td>
                    <td class="px-6 py-4 text-sm text-gray-900 dark:text-[#C5C5C5]">{{item.empId}}</td>
                    <td class="px-6 py-4 text-sm text-gray-900 dark:text-[#C5C5C5]">{{item.complainCategory}}</td>
                    <td class="px-6 py-4 text-sm text-gray-900 dark:text-[#C5C5C5]">
                        <div class="flex flex-col items-center justify-center">
                            <p class="text-[#3E3E3E] dark:text-gray-300">{{ item.createdAt | date:'yyyy/MM/dd' }}</p>
                            <p class="text-[#3E3E3E] dark:text-gray-300">{{ item.createdAt | date:'hh.mm a' }}</p>
                        </div>
                    </td>
                    <td class="px-6 py-4 text-sm text-gray-900 dark:text-[#C5C5C5] cursor-default">

                        <div class="flex items-center justify-center h-full">
                            <span *ngIf="item.status ==='Assigned'"
                                class="bg-[#C8E0FF] w-20 text-center text-[#415CFF] px-3 py-1 rounded-lg">
                                Assigned
                            </span>

                            <span *ngIf="item.status ==='Closed'"
                                class="bg-[#B7FFBE] w-20 text-center text-[#02BB3D] px-3 py-1 rounded-lg">
                                Closed
                            </span>
                        </div>
                    </td>
                    <td class="px-6 py-4 text-sm text-gray-900 dark:text-[#C5C5C5] cursor-pointer">
                        <div class="flex items-center justify-center h-full" (click)="navigateViewReply(item.id)">
                            <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path
                                        d="M3 14C3 9.02944 7.02944 5 12 5C16.9706 5 21 9.02944 21 14M17 14C17 16.7614 14.7614 19 12 19C9.23858 19 7 16.7614 7 14C7 11.2386 9.23858 9 12 9C14.7614 9 17 11.2386 17 14Z"
                                        stroke="#415CFF" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                    </path>
                                </g>
                            </svg>
                        </div>
                    </td>

                    <td class="px-6 py-4 space-x-4">
                        <div class="flex items-center justify-center">
                            <i class="fa-solid fa-file-circle-check text-[#415CFF] text-lg " [ngClass]="{'text-gray-200 cursor-not-allowed': item.reply === null,
                            'text-[#415CFF] cursor-pointer': item.reply !== null}"
                                (click)="item.reply !== null && viewReply(item.id)">
                            </i>
                        </div>
                    </td>

                </tr>
            </tbody>
        </table>

    </div>
    <div *ngIf="hasData" class="flex justify-end items-center my-5 mr-5 pt-3 dark:bg-[#1D1D1F] text-right">
        <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true" [previousLabel]="'Previous'"
            [nextLabel]="'Next'" [screenReaderPaginationLabel]="'Pagination'" [screenReaderPageLabel]="'page'"
            [screenReaderCurrentLabel]="'Youre on page'">
        </pagination-controls>
    </div>

    <div *ngIf="isReplyView" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div class="bg-white dark:bg-[#363636] shadow-lg rounded-lg p-6 w-2/5">
            <div class="flex flex-col items-center gap-4">
                <!-- Envelope Icon -->
                <div class="bg-[#F6F6F6] rounded-full shadow-md py-2 px-3 flex items-center justify-center">
                    <i class="fa-regular fa-envelope text-xl text-gray-700"></i>
                </div>

                <!-- Title -->
                <p class="text-lg font-semibold text-gray-900 dark:text-white">Your Response</p>

                <!-- Message Container -->
                <div class="flex flex-col w-full border-[1px] border-[#D9D9D9] dark:text-white py-4 px-5 rounded-lg">
                    <div class="flex flex-col gap-y-2">
                        <p>
                            {{replyObj.language === 'Sinhala' ? 'හිතවත් ': replyObj.language === 'Tamil' ? 'அன்புள்ள ' :
                            'Dear '}}
                            <span class="font-semibold">{{replyObj.firstNameEnglish}}
                                {{replyObj.lastNameEnglish}},</span>
                        </p>

                        <p *ngIf="replyObj.language === 'Sinhala'">
                            ඔබගේ පැමිණිල්ල නිරාකරණය කර ඇති බව ඔබට දැනුම් දීමට අපි සතුටු වෙමු.
                        </p>

                        <p *ngIf="replyObj.language === 'Tamil'">
                            உங்கள் முறையீடு தீர்வு செய்யப்பட்டதாக தெரிவித்து மகிழ்ச்சியடைகிறோம்.
                        </p>

                        <p *ngIf="replyObj.language !== 'Sinhala' && replyObj.language !== 'Tamil'">
                            We are pleased to inform you that your complaint has been resolved.
                        </p>

                        <div class="border-none outline-none bg-[#F6F6F6] dark:bg-[#363636] rounded-lg w-full  p-1">
                            <textarea rows="5"
                                class="bg-[#F6F6F6] dark:bg-[#363636] resize-none w-full border-none outline-none "
                                cols="6" [(ngModel)]="replyObj.reply" name="reply" placeholder="[ Add message here... ]"
                                disabled=""></textarea>
                        </div>

                        <p class="mb-2 mt-2">
                            {{
                            replyObj.language === 'Sinhala' ? 'ඔබට තවත් ගැටළු හෝ ප්‍රශ්න තිබේ නම්, කරුණාකර අප හා සම්බන්ධ
                            වන්න. ඔබේ ඉවසීම සහ අවබෝධය වෙනුවෙන් ස්තූතියි. '
                            : replyObj.language === 'Tamil' ? 'உங்களுக்கு மேலும் ஏதேனும் சிக்கல்கள் அல்லது கேள்விகள்
                            இருந்தால், தயவுசெய்து எங்களைத் தொடர்பு கொள்ளவும். உங்கள் பொறுமைக்கும் புரிதலுக்கும் நன்றி. '
                            : 'If you have any further concerns or questions, feel free to reach out.'
                            }}
                            <br *ngIf="replyObj.language !== 'Sinhala' && replyObj.language !== 'Tamil'">
                            <span *ngIf="replyObj.language !== 'Sinhala' && replyObj.language !== 'Tamil'">
                                Thank you for your patience and understanding.
                            </span>
                        </p>
                    </div>
                    <div class="flex flex-col mt-1 gap-y-0">
                        <p *ngIf="replyObj.language === 'Sinhala'">
                            මෙයට,<br />
                            {{ templateData.EngName }}<br />
                            Collection Centre Head of {{templateData.companyNameSinhala}}
                        </p>

                        <p *ngIf="replyObj.language === 'Tamil'">
                            இதற்கு,<br />
                            {{ templateData.TamName }}<br />
                            Collection Centre Head of {{templateData.companyNameTamil}}
                        </p>

                        <p *ngIf="replyObj.language !== 'Sinhala' && replyObj.language !== 'Tamil'">
                            Sincerely,<br />
                            {{ templateData.EngName }}<br />
                            Collection Centre Head of {{templateData.companyNameEnglish}}
                        </p>
                    </div>

                    <!-- <p>
                            {{
                                replyObj.language === 'Sinhala' ? 'Collection Centre Head of ' + templateData.companyNameSinhala
                                : replyObj.language === 'Tamil' ? 'Collection Centre Head of ' + templateData.companyNameTamil
                                : 'Collection Centre Head of ' + templateData.companyNameEnglish
                            }}
                        </p> -->
                </div>

                <!-- Close Button -->
                <button
                    class="bg-[#F6F7F9]  text-[#6B7D8C] text-lg  border-2 border-gray-400 rounded-lg px-6 py-2 font-medium shadow-md hover:bg-gray-100"
                    (click)="cancelViewReply()">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>